<template>
    <div>
        <dx-data-grid
            class="data-grid dx-card content-block"
            :data-source="repots"
            :height="gridHeight"
            @content-ready="onContentReady"
            @row-click="onRowClick"
            @context-menu-preparing="addMenuItems"
            @editor-preparing="onEditorPreparing"
            @initialized=initializedGrid
            ref="dataGrid"
        >
            <dx-column data-field="name" :caption="$t('reports.name')" />

            <dx-paging :enabled="true" />
            <dx-pager
                :visible="true"
                :allowed-page-sizes="pageSize"
                display-mode="full"
                :show-page-size-selector="true"
                :show-info="true"
                :show-navigation-buttons="false"
            />
            <dx-filter-row :visible="true" />
            <dx-filter-panel :visible="showFilterPanel" />

            <dx-sorting mode="multiple" />
            <dx-state-storing
                :enabled="true"
                type="custom"
                :customLoad="stateLoad"
                :customSave="stateSave"
            />
        </dx-data-grid>

        <CustomColumnChooser
            :visible="visible"
            :columns="columns"
            :onApply="onApply"
            :onHiding="onHiding"
        />
    </div>
</template>
  
<script>
import { mapCacheActions } from 'vuex-cache';

import baseView from "../base.vue";
import appInfo from "../../app-info";

import DxDataGrid, {
    DxColumn, DxFilterRow, DxFilterPanel, DxStateStoring, DxPaging, DxPager, DxSorting
} from "devextreme-vue/data-grid";

import CustomColumnChooser from "@/components/column-chooser/CustomColumnChooser.vue";

import { DataDrid } from "@/mixins/dataDridMixin";
import { AclHandler } from "@/services/acl-handler";

import {
  PAGE_HEADER_HEIGHT,
  PAGE_PADDING,
  PAGE_FOOTER_HEIGHT,
  GRID_HEADER_HEIGHT,
  GRID_FILTER_ROW_HEIGHT,
  GRID_FILTER_PANEL_HEIGHT,
  GRID_PAGER_HEIGHT
} from '@/shared/consts/layout';

export default {
    extends: baseView,
    mixins: [DataDrid],
    components: {
        DxDataGrid, DxColumn, DxFilterRow, DxFilterPanel, DxStateStoring, CustomColumnChooser, DxPaging, DxPager,
        DxSorting
    },
    data() {
        return {
            isCloudMode: this.$store.getters.isCloudMode,
            repots: []
        };
    },
    computed: {
        appUser() {
            return this.$store.getters.user;
        },
        aclUser() {
            return new AclHandler(this.appUser, this.isCloudMode);
        },
        showFilterPanel() {
            return this.aclUser.hasGrantForOperation('BTN_CLEAR_FILTER', 'EXECUTE') || false;
        },
        sumGap() {
            return PAGE_HEADER_HEIGHT + PAGE_PADDING + PAGE_FOOTER_HEIGHT;
        },
        gridHeight() {
            const appHeightSize = this.$store.getters.appContainerSize.height;
            return (appHeightSize || 800) - this.sumGap;
        },
        gridBodyHeight() {
            return this.gridHeight - GRID_HEADER_HEIGHT - GRID_FILTER_ROW_HEIGHT - (this.showFilterPanel ? GRID_FILTER_PANEL_HEIGHT : 0) - GRID_PAGER_HEIGHT;
        },
    },
    methods: {
        ...mapCacheActions(['getReportsType']),
        onEditorPreparing(e) {
            this.applyFilterRowTimeout(e);
        },
        onContentReady(e) {
            this.addFitToPageHeightButton(e);
        },
        onRowClick(e) {
            if (window.getSelection().focusOffset !== window.getSelection().anchorOffset)
                return;

            if (e.event.metaKey || e.event.ctrlKey) {
                const routeData = this.$router.resolve({
                    name: "report",
                    params: {
                        code: e.data.code
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                this.$router.push({
                    name: "report",
                    params: {
                        code: e.data.code
                    }
                });
            }
        }
    },
    async created() {
        this.gridStateKey = 'gridReports';

        this.repots = await this.getReportsType();

        document.title = `${appInfo.title} - ${this.$t('reports.title')}`;
        this.$store.commit("setBreadcrumb", [{
            link: "/reports",
            title: this.$t('reports.title')
        }]);
    },
    beforeDestroy() {
        const state = this.dataGrid.state();
        this.stateSave(state);
    },
};
</script>
  
<style lang="scss">

</style>